import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { Breakpoint, BreakpointState, MediaQueryService } from '../../services/media-query.service';
import { DataAnalyticsTaggingConstants } from '../data-analytics-tagging/data-analytics-tagging.constants';
import { DataAnalyticsTaggingService } from '../data-analytics-tagging/data-analytics-tagging.service';
import { HelpDesktopComponent } from './help-desktop.component';
import { HelpMobileComponent } from './help-mobile.component';

@Component({
  selector: 'td-wb-help',
  templateUrl: 'help.component.html',
  styleUrls: ['help.component.scss'],
  imports: [
    HelpDesktopComponent,
    AsyncPipe,
    HelpMobileComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HelpComponent implements OnInit {
  @Input() articleId: string;
  @Output('close') readonly closeEvent: EventEmitter<void> = new EventEmitter<void>();

  breakpointChanges$: Observable<BreakpointState>;

  constructor(private mediaQueryService: MediaQueryService,
              private dataAnalyticsTaggingService: DataAnalyticsTaggingService) {
  }

  ngOnInit(): void {
    this.breakpointChanges$ = this.mediaQueryService.observe(Breakpoint.SM);
  }

  close(): void {
    this.dataAnalyticsTaggingService.emitTaggingEvent(DataAnalyticsTaggingConstants.defaultModalCloseEvent);
    this.closeEvent.emit();
  }

  changeArticleId(event: string): void {
    if (this.articleId !== event) {
      this.articleId = undefined;
    }
  }
}
